<template>
  <div class="profile-box-container w-100">
    <div class="d-flex justify-space-between align-items-center w-100 mb-3">
      <label class="profile-box-title">{{ $t("contact_info") }}</label>
    </div>

    <!-- Skeleton State -->
    <template v-if="!profile || !profile.email">
      <div class="d-flex align-items-center justify-space-between py-5">
        <div class="profile-box-second-text">{{ $t("email") }}</div>
        <v-skeleton-loader type="text" width="180" height="20" />
      </div>
      <v-divider></v-divider>
      <div class="d-flex align-items-center justify-space-between py-5">
        <div class="profile-box-second-text">{{ $t("phone_number") }}</div>
        <v-skeleton-loader type="text" width="120" height="20" />
      </div>
    </template>

    <!-- Loaded State -->
    <template v-else>
      <div class="d-flex align-items-center justify-space-between py-5">
        <div class="profile-box-second-text">{{ $t("email") }}</div>
        <div class="profile-box-second-text">{{ profile.email }}</div>
      </div>
      <v-divider></v-divider>
      <div class="d-flex align-items-center justify-space-between py-5">
        <div class="profile-box-second-text">{{ $t("phone_number") }}</div>
        <div class="profile-box-second-text">{{ profile.mobile }}</div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "Addresses",
  props: ["profile"],
};
</script>
